
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IGiaiDoan } from "../../../model/respone/ke-hoach/IGiaiDoan";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eGiaiDoanActionsObj = {
    LOAD_START: "",
    LOAD_SUCCESS: {} as IGiaiDoan[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as IGiaiDoan | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as IGiaiDoan,
    SAVE_SUCCESS: {} as IGiaiDoan,
    SAVE_ERROR: "",

    DELETE_START: {} as IIdsRequest,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    CHANGE_SELECTED_IDS: {} as number[]
};
export const eGiaiDoanActionIds = generateActionTypeIds(
    eGiaiDoanActionsObj,
    "GIAI_DOAN"
);
export type IGiaiDoanActionTypes = IGenericActionType<
    typeof eGiaiDoanActionsObj,
    "GIAI_DOAN"
>;
